export default __webpack_public_path__ + "static/media/img-trabajo-5.bef659a7.jpg";